import { createContext } from "react";
import { GameComponentForGame, SetVariableData } from "../implementationTypes";

export type GameSituationContextType = {
  componentClickCallBack: (component: GameComponentForGame, evt: React.MouseEvent) => void;
  positionClickCallBack: (
    destinationId: string,
    positionIndex: string | number,
    positionName: string,
    visible: any,
    evt: React.MouseEvent,
  ) => void;
  discardComponentCallBack: (componentData: GameComponentForGame, destination: string, evt: React.MouseEvent) => void;
  optionSelectCallBack: (options: SetVariableData, evt: React.ChangeEvent) => void;
  macroClickCallBack: (
    name: string,
    options: {
      [key: string]: any;
    },
    buttonData: {
      [key: string]: any;
    },
  ) => void;
  bankReveal: GameComponentForGame | null;
  addGameIconsToText: (text: string) => React.ReactNode;
  selectedComponent: GameComponentForGame | null;
  displayTooltips: boolean;
  getSelectedComponent?: () => GameComponentForGame | null;
};

export let gameSituationContext = createContext<GameSituationContextType | null>(null);
